import CloseIcon from "assets/icons/close.svg?react";
import casesService from "api/casesService";
import filterService from "api/filterService";
import Button from "components/Button";
import HollowButton from "components/HollowButton";
import Input from "components/Input";
import { IStatus } from "dto/IStatus";
import { ITag, TagType } from "dto/ITag";
import { useEffect, useMemo, useState } from "react";
import { calculateKindItems } from "utils/calculateKindItems";
import { reverseKindItems } from "utils/reverseKindItems";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import tagsService from "api/tagsService";
import statusService from "api/statusService";
import SelectFlagNew from "components/SelectFlagNew";
import StatusBadge from "components/StatusBadge";
import ChooseMethods from "components/ChooseMethods";
import Chip from "components/Chip";
import { ENotificationType, notification } from "utils/notification";
import { logger } from "utils/logger";
import { ListType } from "dto/ListType";
import { getTagTypeForListType } from "utils/getTagTypeForListType";
import SearchLabel from "components/SearchLabel";
import { useTranslation } from "react-i18next";

export const CreateFilterIncomingModal: FC<Props> = ({
  typed,
  listType,
  listRef,
  toggle,
  getFilters,
  initialValues,
  staticId,
}) => {
  const { t } = useTranslation();
  const { data: tagsData } = tagsService.useGetTags(
    false,
    getTagTypeForListType(listType)
  );
  const { data: statusesData } = statusService.useGetStatuses(null, listType);

  const tagd = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const statused = useMemo(() => statusesData?.data ?? [], [statusesData]);

  const [position, setPosition] = useState([0, 0]);
  const [showed, setShowed] = useState("none");
  const [name, setName] = useState("");
  const [tags, setTags] = useState<ITag[]>([]);
  const [statuses, setStatuses] = useState<IStatus[]>([]);

  const { mutate: createFilter } = filterService.useCreateFilterForCategory();
  const { mutate: deleteFilter } = filterService.useDeleteFilterForCategory();
  const { mutate: createCaseFilter } = casesService.useCreateFilterForCases();
  const { mutate: deleteCasesFilter } = casesService.useDeleteFilter();

  const { data: staticFilterData } = filterService.useGetStaticFilter(
    staticId,
    staticId != null
  );

  const [types, setTypes] = useState(initialValues ? [] : typed);

  useEffect(() => {
    if (!initialValues) return;

    setName(initialValues?.Name ?? "");

    if (initialValues?.TagIds) {
      const findedTags = tagd?.filter((tag: ITag) =>
        initialValues?.TagIds?.find((iTag) => tag.Id === iTag)
      );
      setTags(findedTags ?? []);
    }
    const findedStatuses = statused?.filter((status: IStatus) =>
      initialValues?.StatusIds?.find((iStatus) => status.Id === iStatus)
    );

    if (initialValues.ItemKinds !== 0) {
      typed = typed.map((typeItem) => {
        typeItem.active = false;
        return typeItem;
      });
    }

    const kindItems = reverseKindItems(initialValues.ItemKinds);
    const kindValues = Object.entries(kindItems);

    const newTyped = typed.map((type) => {
      const key = kindValues.find((kindKey) => kindKey[0] === type.id);

      if (key) {
        type.active = key[1];
      }
      return type;
    });

    setStatuses(findedStatuses);
    setTypes(newTyped);
  }, [initialValues, tagd]);

  useEffect(() => {
    if (!staticFilterData?.data) return;

    setName(staticFilterData?.data?.Name ?? "");

    if (staticFilterData?.data?.TagIds) {
      const findedTags = tagd?.filter((tag: ITag) =>
        staticFilterData?.data?.TagIds?.find((iTag) => tag.Id === iTag)
      );
      setTags(findedTags ?? []);
    }
    const findedStatuses = statused?.filter((status: IStatus) =>
      staticFilterData?.data?.StatusIds?.find(
        (iStatus) => status.Id === iStatus
      )
    );

    if (staticFilterData?.data.ItemKinds !== 0) {
      typed = typed.map((typeItem) => {
        typeItem.active = false;
        return typeItem;
      });
    }

    const kindItems = reverseKindItems(staticFilterData?.data.ItemKinds);
    const kindValues = Object.entries(kindItems);

    const newTyped = typed.map((type) => {
      const key = kindValues.find((kindKey) => kindKey[0] === type.id);

      if (key) {
        type.active = key[1];
      }
      return type;
    });

    setStatuses(findedStatuses);
    setTypes(newTyped);
  }, [staticFilterData, tagd]);

  const handleChooseTag = (tag: ITag | null) => setTags([...tags, tag!]);
  const handleRemoveTag = (removeTag: ITag) =>
    setTags(tags.filter((tag) => tag.Id !== removeTag.Id));
  const handleChooseStatus = (status: IStatus) =>
    setStatuses([...statuses, status]);
  const handleDelete = () => {
    if (initialValues) {
      if (listType === ListType.Cases) {
        deleteCasesFilter({ Id: initialValues.Id });
      } else {
        deleteFilter({ Id: initialValues.Id });
      }
    }

    setTimeout(() => {
      getFilters(listType);
    }, 50);
    toggle(false);
  };

  const handleCreate = () => {
    // cases id 3

    const data = {
      Name: name,
      List: listType,
      Id: initialValues?.Id ? initialValues.Id : undefined,
      StaticId: staticId,
      TasksCompleted: 0,
      Tasks: 3,
      TagIds: tags.map((tag) => tag.Id),
      StatusIds: statuses?.map((a) => a.Id) ?? [],
      Status: 0,
      Return: 3,
      Handled: 3,
      Delivery: 3,

      ItemKinds: calculateKindItems({
        CourtPortalDeliverance:
          types?.find((type) => type.id === "CourtPortalDeliverance")?.active ??
          false,
        CourtPortalDocument:
          types?.find((type) => type.id === "CourtPortalDocument")?.active ??
          false,
        Parcel: types?.find((type) => type.id === "Parcel")?.active ?? false,
        ContactMessage:
          types?.find((type) => type.id === "ContactMessage")?.active ?? false,
        EDeliveryMessage:
          types?.find((type) => type.id === "EDeliveryMessage")?.active ??
          false,
        NotaMessage:
          types?.find((type) => type.id === "NotaMessage")?.active ?? false,
        CourtPortalApplication:
          types?.find((type) => type.id === "CourtPortalApplication")?.active ??
          false,
        Email: types?.find((type) => type.id === "Email")?.active ?? false,
        OutgoingParcel:
          types?.find((type) => type.id === "OutgoingParcel")?.active ?? false,
      }),
    };

    if (listType === ListType.Cases) {
      createCaseFilter(data, {
        onSuccess: () => {
          getFilters(listType);
          toggle(false);
        },
      });
      return;
    }

    createFilter(data, {
      onSuccess: () => {
        getFilters(listType);
        toggle(false);
      },
      onError: (e) => {
        logger.error("Error while creating list filter", e);
        notification({
          title: t("errors.occurred"),
          text: t("errors.somethingWentWrongTitle"),
          type: ENotificationType.ERROR,
        });
      },
    });
  };

  useEffect(() => {
    if (listRef.current) {
      const left = listRef.current.offsetLeft + listRef.current.offsetWidth;
      const top = listRef.current.offsetTop + listRef.current.offsetHeight / 2;

      setPosition([left, top]);
      setShowed("block");
    }
  }, [listRef]);

  return (
    <div
      style={{ left: position[0], top: position[1], display: showed }}
      className={styles.modal}
    >
      {/* <i className={classNames(styles.arrow, styles.left)}></i> */}
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            {initialValues || staticId ? t("common.list") : t("navigation.newList")}
          </div>
          <div onClick={() => toggle(false)} className={styles.close}>
            <CloseIcon className={styles.closeButton} />
          </div>
        </div>
        <Input
          value={name}
          placeholder={t("forms.listName")}
          onChange={(text) => setName(text)}
          label={t("forms.listNameLabel")}
        />

        <div className={styles.types}>
          {/* {!!types.length && (
            <>
              <div className={styles.typesHeader}>Rodzaje przesyłek</div>
              <div className={styles.typesList}>
                {types.map((type) => (
                  <div className={styles.box}>
                    <div className={styles.typeName}>{type.name}</div>
                    <div className={styles.typeCheckbox}>
                      <SecondCheckbox
                        value={type.active}
                        onChange={(state) =>
                          handleChangeState(type.name, state)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )} */}

          <div className={styles.options}>
            {(listType === ListType.Incoming ||
              listType === ListType.Outgoing) && (
              <ChooseMethods
                types={types}
                onChoose={(type) => {
                  setTypes(
                    types.map((typeItem) => {
                      if (type?.id === typeItem.id) {
                        typeItem.active = true;
                      }
                      return typeItem;
                    })
                  );
                }}
              />
            )}
            <SelectFlagNew
              selectedStatus={null}
              onChoose={handleChooseStatus}
              listType={listType}
            />

            <SearchLabel
              label={t("common.label")}
              type={TagType.Incoming}
              onChoose={handleChooseTag}
            />
          </div>
          <div className={styles.tagList}>
            {types
              .filter((typeItem) => typeItem.active)
              .map((typeItem) => {
                return (
                  // <div className={styles.tag}>
                  //   {<typeItem.image className={styles.tagImage} />} {typeItem.name}
                  //   <CloseIcon
                  //     onClick={(e) => {
                  //       e.stopPropagation();
                  //       setTypes(
                  //         types.map((a) => {
                  //           if (a.id === typeItem.id) {
                  //             typeItem.active = false;
                  //           }
                  //           return a;
                  //         })
                  //       );
                  //     }}
                  //     className={`${styles.remove}`}
                  //   />
                  // </div>
                  <Chip
                    element={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <typeItem.image className={styles.tagImage} /> {typeItem.name}
                      </div>
                    }
                    onDelete={() => {
                      setTypes(
                        types.map((a) => {
                          if (a.id === typeItem.id) {
                            typeItem.active = false;
                          }
                          return a;
                        })
                      );
                    }}
                  />
                );
              })}
            {tags.map((tag) => (
              <Chip
                element={<>{tag.Name}</>}
                onDelete={() => {
                  handleRemoveTag(tag);
                }}
              />
            ))}
            {statuses && (
              <div className={styles.data}>
                {statuses?.map((s) => (
                  <StatusBadge
                    onRemove={(stat) => {
                      setStatuses(statuses?.filter((a) => a.Id !== stat.Id));
                    }}
                    status={s}
                    showName
                  />
                ))}
              </div>
            )}
          </div>

          <div className={styles.buttonsWrapper}>
            {!staticId && (
              <HollowButton text={t("common.delete")} onClick={() => handleDelete()} />
            )}
            <Button
              text={t("common.save")}
              onClick={() => handleCreate()}
              disabled={!name.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
